import { Directive, inject } from '@angular/core';

import { TabBase } from '../components/TabPanel/tab-base';

@Directive({
  selector: 'button[tabNext]',
  host: {
    '(click)': 'this.tab.selectNext.emit()'
  }
})
export class TabNextButtonDirective {
  tab = inject(TabBase);
}